// Pure status predicates used to classify a transaction's approval state.
//
// Historical note: this file was once `approval-state-machine.ts` and contained
// a client-side transition validator (`transitionApprovalStatus`, `VALID_TRANSITIONS`,
// `ApprovalAction`) built for the Phase 01 mock-store era. That validator was never
// wired up to the real AppSync flow — approve/reject/resubmit hooks write
// `approvalStatus` directly via `updateTransaction` and the UI gates invalid
// transitions by conditional rendering. The validator was deleted as part of
// Phase 07 cleanup. When the atomic approve/reject Lambda lands (backlog 999.2),
// transition enforcement should live server-side inside that Lambda, not here.

import { ApprovalStatus } from "../API";

// Manager inbox: items needing reviewer action (pending or changesRequested)
export const isInboxStatus = (
  status: ApprovalStatus | null | undefined
): boolean =>
  status === ApprovalStatus.pending ||
  status === ApprovalStatus.changesRequested;

// Employee/UI: items needing the employee's attention (inbox + rejected)
export const isActionableStatus = (
  status: ApprovalStatus | null | undefined
): boolean => isInboxStatus(status) || status === ApprovalStatus.rejected;
